export class Item {
    constructor(
    	public userId?: number,
    	public password?: string,
        public passwordConfirm?: string,
        public oldPassword?: string,
    ) {
    }
}
